import { default as axios } from "axios";
import { IConfiguration } from "../../domain/configuration";

export class ConfigurationRepository {
  public async getConfiguration(): Promise<IConfiguration> {
    return (await axios.get("/api/configuration/frontend/get")).data;
  }
}
